import { ConsentItemStateChangeDataEnum } from '@ysura/common';

import { createEnumMapperFunction } from '@/services/graphql/mappers/utils';
import { ConsentItemStateChange } from '@/services/graphql/types';

export const mapperConsentItemStateChangeDataEnum = createEnumMapperFunction(
  ConsentItemStateChange,
  ConsentItemStateChangeDataEnum
);
